import merge from "lodash/merge";
import {
    IChartApi,
    ISeriesApi,
    ISeriesPrimitive,
    ISeriesPrimitiveAxisView,
    ISeriesPrimitivePaneView,
    PrimitiveHoveredItem,
    SeriesAttachedParameter,
    SeriesOptionsMap,
    Time
} from 'lightweight-charts'
import PlusIconPaneView from "./plusIcon.paneView";
import { SQUARE_WIDTH } from "./plusIcon.paneRenderer";

export type PlusIconDrawingOptions = {
    price: Time,
    visible?: boolean
    hovered?: boolean
    fillColor?: string
    hoverFillColor?: string
}

class PlusIconDrawing implements ISeriesPrimitive<Time> {
    options: PlusIconDrawingOptions
    series: ISeriesApi<any>
    chart: IChartApi;
    paneView: PlusIconPaneView;
    requestUpdate() {
    };

    constructor(options: PlusIconDrawingOptions) {
        this.options = merge({visible: true}, options);
    }
    
    attached(param: SeriesAttachedParameter<Time, keyof SeriesOptionsMap>): void {
        const { requestUpdate, chart, series } = param
        this.requestUpdate = requestUpdate
        this.chart = chart;
        this.series = series;
    }

    setOptions(options: Partial<PlusIconDrawingOptions>) {
        this.options = merge(this.options, options);
        this.requestUpdate();
    }

    paneViews(): readonly ISeriesPrimitivePaneView[] {
        if (!this.paneView) {
            this.paneView = new PlusIconPaneView(this);
        }
        return [this.paneView]
    }

    priceAxisPaneViews(): readonly ISeriesPrimitivePaneView[] {
        return [];
    }

    timeAxisPaneViews(): readonly ISeriesPrimitivePaneView[] {
        return [];
    }

    priceAxisViews(): readonly ISeriesPrimitiveAxisView[] {
        return [];
    }

    timeAxisViews(): readonly ISeriesPrimitiveAxisView[] {
        return [];
    }
    hitTest(x: number, y: number): PrimitiveHoveredItem | null {
        if (!this.options.visible) return null;
        const dpr = window.devicePixelRatio;
        const timescale = this.chart.timeScale();
        const chartHeight = this.chart.options().height;
        const timeScaleHeight = timescale.height();
        const scaledY = y*dpr;
        const scaledWidth = SQUARE_WIDTH * dpr;
        if (scaledY < chartHeight*dpr - timeScaleHeight*dpr - scaledWidth) {
            return null;
        }
        return {
            externalId: "plusIcon",
            cursorStyle: "pointer",
            zOrder: "top"
        }
    }
    destroy() {
        this.paneView?.destroy();
        this.paneView = null;
    }
}

export default PlusIconDrawing